export default __webpack_public_path__ + "static/media/Scenery08.54ae5aee.jpg";